import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const optionCss = ":host{--option-font-size:var(--tt-font-size-sm)}.option{font:var(--tt-font-standard)}.option[aria-disabled]:not([aria-disabled=false]){color:var(--tt-color-green-gray-500)}.option:focus-visible{outline:none}";

let id = 0;
const Option = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.inputId = `option-${++id}`;
    this.label = undefined;
    this.value = undefined;
    this.selected = false;
    this.disabled = false;
  }
  /** Sets focus on the range. */
  async setFocus(options) {
    this.option.focus(options);
  }
  /** Gets the label of the option. */
  async getLabel() {
    var _a;
    return (_a = (this.label || this.element.textContent)) !== null && _a !== void 0 ? _a : `${this.value}`;
  }
  render() {
    var _a;
    return (h("span", { id: this.inputId, class: "option", ref: (el) => {
        this.option = el;
      }, "aria-disabled": this.disabled, tabIndex: 0, role: "option" }, h("slot", null, (_a = this.label) !== null && _a !== void 0 ? _a : this.value)));
  }
  get element() { return this; }
  static get style() { return optionCss; }
}, [1, "tt-option", {
    "label": [1],
    "value": [8],
    "selected": [516],
    "disabled": [4],
    "setFocus": [64],
    "getLabel": [64]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-option"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-option":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Option);
      }
      break;
  } });
}

export { Option as O, defineCustomElement as d };
